import { createI18n } from 'vue-i18n'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/fr' // Add locales you need
import 'dayjs/locale/ko'
import 'dayjs/locale/zh-cn'

dayjs.extend(relativeTime)

import {
  en as vuetifyEn,
  ko as vuetifyKo,
  fr as vuetifyFr,
  zhHans as vuetifyCn
} from 'vuetify/locale' // Vuetify locales
import en from '@/locales/en.json'
import ko from '@/locales/ko.json'
import fr from '@/locales/fr.json'
import cn from '@/locales/cn.json'

const messages = {
  en: {
    $vuetify: vuetifyEn, // Merge Vuetify's English translations
    ...en

    // custom translations
  },
  ko: {
    $vuetify: vuetifyKo, // Merge Vuetify's Korean translations
    ...ko // custom translations
  },
  fr: {
    $vuetify: vuetifyFr, // Merge Vuetify's French translations
    ...fr // custom translations
  },
  cn: {
    $vuetify: vuetifyCn, // Merge Vuetify's Chinese translations
    ...cn // custom translations
  }
}

const numberFormats = {
  en: {
    currency: {
      style: 'currency',
      currency: 'USD',
      notation: 'standard',
      maximumFractionDigits: 0
    },
    decimal: {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    },
    number: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    },
    percent: {
      style: 'percent',
      useGrouping: false
    }
  },
  ko: {
    currency: {
      style: 'currency',
      currency: 'KRW',
      useGrouping: true,
      currencyDisplay: 'symbol'
    },
    decimal: {
      style: 'decimal',
      minimumSignificantDigits: 2,
      maximumSignificantDigits: 2
    },
    number: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    },
    percent: {
      style: 'percent',
      useGrouping: false
    }
  }
}

const datetimeFormats = {
  en: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  ko: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  fr: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  cn: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  }
}

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages,
  numberFormats,
  datetimeFormats
})

export default i18n
